export const prepareClassificationLabel = (
  locale: string,
  label: string,
  altText: string,
  key: number
): string => {
  const getLocalizedLabel = () => {
    return locale === 'en'
      ? `${label} image for: ${altText}, Image ${key + 1}`
      : `صورة ${label} لـ: ${altText}، صورة رقم ${key + 1}`;
  };
  if (label) {
    return getLocalizedLabel();
  }
  return altText;
};